module.exports = __webpack_public_path__ + "static/media/gotv.e56df528.svg";